import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import profileImg from "../../assets/home-main.png";
import Tilt from "react-parallax-tilt";

const About = () => {
  return (
    <Container fluid className="about section home-about-section" id="about">
      <Container>
        <Row>
          <Col md={8} className="home-about-description">
            <h1
              style={{
                fontSize: "2.6em",
              }}
            >
              ABOUT <span className="yellow"> ME </span>
            </h1>
            <p
              id="user-detail-intro"
              className="home-about-body"
              style={{
                fontSize: "1em",
                textAlign: "justify",
              }}
            >
              An aspiring frontend web developer who has a strong command of{" "}
              <b className="yellow">HTML</b>, <b className="yellow">CSS</b>, and{" "}
              <b className="yellow">JavaScript</b>, and is proficient in the
              MERN stack (<b className="yellow">MongoDB</b>,{" "}
              <b className="yellow">Express.js</b>,{" "}
              <b className="yellow">React.js</b>,{" "}
              <b className="yellow">Node.js</b>). A constant learner and has the
              ability to adapt to new technologies. Capable of working in teams
              by providing valuable support.
            </p>
          </Col>
          <Col md={4} className="myAvtar">
            <Tilt>
              <img
                src={profileImg}
                className="img-fluid"
                style={{ borderRadius: "10%" }}
                alt="avatar"
              />
            </Tilt>
          </Col>
        </Row>
      </Container>
    </Container>
  );
};

export default About;
